import { defaultChangePasswordRepository } from "api/repositories/changePassword/ChangePasswordRepository";
import popUpComponent from "components/generalComponents/popUpComponent/PopUpComponent";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { productCache } from "utils/cache/productCache";
import { strings } from "utils/localizedStrings";

const ChangePasswordViewModel = () => {
  const history = useNavigate();
  const [info, setInfo] = React.useState<Record<string, any>>({});
  const [error, setError] = React.useState<Record<string, any>>({});
  const [loading, setLoading] = React.useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);

  const onSubmit = async () => {
    try {
      if (!info.oldPassword && !info.password && !info.confirmPassword) {
        return setError({
          oldPassword: true,
          password: true,
          confirmPassword: true,
        });
      }
      if (!info.oldPassword) return setError({ ...error, oldPassword: true });
      if (!info.password) return setError({ ...error, password: true });
      if (!info.confirmPassword)
        return setError({
          ...error,
          confirmPassword: strings.ChangePassword.Message.InvalidPass,
        });

      if (info.password !== info.confirmPassword) {
        return setError({
          ...error,
          confirmPassword: strings.ChangePassword.Message.UnmatchedPass,
        });
      }
      setLoading(true);

      const body = {
        currentPassword: info.oldPassword,
        newPassword: info.confirmPassword,
      };

      const res = await defaultChangePasswordRepository?.changePassword(body);
      if (res) {
        popUpComponent.success(
          strings.ChangePassword.Message.ChangePassSucceed,
          5
        );
        setIsSuccess(true);
        localStorage?.clear();
        sessionStorage?.clear();
        productCache?.resetCache("");
        history("/login");
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
      popUpComponent.error(err && err.error?.message, 4);
    } finally {
      setLoading(false);
    }
  };

  const handleOnChange = (e) => {
    setError({});
    setInfo({ ...info, [e.target.name]: e.target.value });
  };
  return {
    info,
    error,
    loading,
    isSuccess,
    onSubmit,
    handleOnChange,
  };
};

export default ChangePasswordViewModel;
